export const BRAND = {
  email: "support@rebaros.app",
  price: "$24.99",
};

// Paste store URLs here once published — an empty string shows a "Coming Soon" badge.
export const STORE = {
  googlePlay: "",
  appStore: "",
};

export const IMAGES = {  hero: "https://images.pexels.com/photos/19132573/pexels-photo-19132573.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=1900",
  squat:
    "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  chalk:
    "https://images.unsplash.com/photo-1570642503856-55972f7fb58a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  deadlift:
    "https://images.pexels.com/photos/15373906/pexels-photo-15373906.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
  back: "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  focus:
    "https://images.pexels.com/photos/19132573/pexels-photo-19132573.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
  barbell:
    "https://images.unsplash.com/photo-1706029831385-1c89922848eb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const TRANSFORM = [
  {
    id: "man",
    name: "Male Athlete",
    label: "12-week block",
    before:
      "https://static.prod-images.emergentagent.com/jobs/e50d0090-62af-4c09-8326-ab5fbc84ecfa/images/c34ca37a63d26892455ffbbb4016e46f66bd186a94e307f61c8826990f82a34f.jpeg",
    after:
      "https://static.prod-images.emergentagent.com/jobs/e50d0090-62af-4c09-8326-ab5fbc84ecfa/images/9bb7f4b156ff7a6fabe12804f0381e84c73bb1ed8d3abe0ec22386b15262ffbd.jpeg",
    stats: [
      { k: "Weight", v: "-9.4 kg" },
      { k: "Strength", v: "+22%" },
      { k: "Streak", v: "31 days" },
    ],
    achievements: [
      { icon: "flame", label: "30-Day Streak" },
      { icon: "dumbbell", label: "Bench +20kg" },
      { icon: "trophy", label: "First Muscle-up" },
    ],
  },
  {
    id: "woman",
    name: "Female Athlete",
    label: "12-week block",
    before:
      "https://static.prod-images.emergentagent.com/jobs/e50d0090-62af-4c09-8326-ab5fbc84ecfa/images/8f3f7e67736e4a8ba2a676678781b202ec09e32bec1adec1515201656c58a472.jpeg",
    after:
      "https://static.prod-images.emergentagent.com/jobs/e50d0090-62af-4c09-8326-ab5fbc84ecfa/images/b0b0b35d6dcd7b8e8eb304a40b28d35c9bafe9473378594020466445df9ee8ac.jpeg",
    stats: [
      { k: "Weight", v: "-7.1 kg" },
      { k: "Strength", v: "+28%" },
      { k: "Streak", v: "24 days" },
    ],
    achievements: [
      { icon: "medal", label: "First Pull-up" },
      { icon: "dumbbell", label: "Squat +25kg" },
      { icon: "flame", label: "21-Day Streak" },
    ],
  },
];

export const FEATURES = [
  {
    id: "ai-programs",
    title: "AI Programs",
    desc: "Bodyweight, home gym or full gym — a plan built from your goals, injuries and equipment, and rebuilt as you progress.",
    tag: "01",
  },
  {
    id: "live-workouts",
    title: "Live Workouts",
    desc: "Track every set. Auto-detect PRs. Skip Tabata rounds. Voice-log your reps while your hands are chalked up.",
    tag: "02",
  },
  {
    id: "macro-tracking",
    title: "Macro Tracking",
    desc: "3 million foods. Barcode scan, photo AI and voice input. Imperial units — no gram-math required.",
    tag: "03",
  },
  {
    id: "exercise-demos",
    title: "Exercise Demos",
    desc: "Every exercise ships with a play button. Form videos matched to you, so you never guess a movement again.",
    tag: "04",
  },
  {
    id: "injury-aware",
    title: "Injury-Aware Coach",
    desc: "Flag a pain point and the AI Coach swaps lifts around bad joints. You never have to train through injury.",
    tag: "05",
  },
  {
    id: "private",
    title: "Private by Default",
    desc: "Your data stays yours. No feeds, no follows, no ads. You decide exactly what to share.",
    tag: "06",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    head: "The barbell doesn't negotiate.",
    body: "Neither do we. ReBarOS is built for athletes who show up when it's cold, dark and heavy — and who want a system that respects the effort.",
  },
  {
    n: "02",
    head: "Train like it's your job.",
    body: "Structured overload. Real periodization. Every rep logged, every load calculated. Your program adapts to the athlete you're becoming.",
  },
  {
    n: "03",
    head: "Eat like it matters.",
    body: "Because it does. Macro precision, barcode speed and AI meal ideas that make fueling the strongest version of you effortless.",
  },
];
